// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BJca","buttons":"styles_buttons__uo0kM"};